import React from 'react';
import { is } from 'ramda';
import { isPresent } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

import useStyles from './useStyles';

const COUNT_MAX = 99;

const Search = props => {
  const { label, count } = props;
  const classes = useStyles();

  const shouldShowCount = isPresent(count) && is(Number, count);
  const normalizedCount = count > COUNT_MAX ? `${COUNT_MAX}+` : count;

  return (
    <div className={classes.container}>
      <Typography variant="h2">{label}</Typography>
      {shouldShowCount && (
        <Typography variant="subtitle1" colors="inherit" className={classes.count}>
          {normalizedCount}
        </Typography>
      )}
    </div>
  );
};

Search.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number,
};

Search.defaultProps = {
  count: null,
};

export default Search;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/components/Tabs/components/LabelWithBadge/LabelWithBadge.js